import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as ReactDOMClient from 'react-dom/client';

// Use consistent styling
import 'sanitize.css/sanitize.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import 'react-phone-input-2/lib/style.css';
import 'react-loading-skeleton/dist/skeleton.css';
// Import root app
import { HelmetProvider } from 'react-helmet-async';

import { reportWebVitals } from './reportWebVitals.ts';

// Initialize languages
import './locales/i18n';
import WebFont from 'webfontloader';
import App from './App.tsx';
import { StrictMode } from 'react';

import * as Sentry from '@sentry/react';
import { message } from 'antd';

// Antd message 전역 설정
message.config({
  top: 30,
  maxCount: 4,
  duration: 3,
});

// Sentry 초기화
if (import.meta.env.VITE_ENABLE_SENTRY === 'true') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_NODE_ENV || 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      /.*\.bynova\.net/,
      /^https:\/\/.*\/api\/.*/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

// global.Buffer = global.Buffer || require("buffer").Buffer;
WebFont.load({ google: { families: ['Roboto:300,400,500'] } });

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

ReactDOMClient.createRoot(MOUNT_NODE!).render(
  <HelmetProvider>
    <StrictMode>
      <App />
    </StrictMode>
  </HelmetProvider>
);
// Hot reloadable translation json files
if (import.meta.hot) {
  import.meta.hot.accept(['./locales/i18n'], () => {
    // No need to render the App again because i18next works with the hooks
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: http://bit.ly/CRA-vitals
reportWebVitals();
